import styled from 'styled-components';
import { color, fontSize, fontWeight, radius, screen, spacing } from 'theme';

export const StyledItem = styled.figure`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing('md')};
  text-align: center;
  margin: 0;
  transition: 0.3s;
`;

export const StyledItems = styled.div`
  display: flex;
  width: '100%';
  height: '100%';
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    justify-content: center;
    align-items: end;
    gap: ${spacing('xl4')};
  }
`;
export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  min-height: 400px;
`;

export const StyledCaption = styled.figcaption`
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('xl2')};
  line-height: 1.25;
  white-space: nowrap;
`;

export const StyledValueContainer = styled.div`
  display: grid;
  justify-items: center;
  align-items: end;

  > div {
    border-radius: ${radius('full')};
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--coeficient) * 15rem);
    aspect-ratio: 1/1;
    grid-column-start: 1;
    grid-row-start: 1;

    @media (min-width: ${screen('lg')}) {
      width: calc(var(--coeficient) * 19.5rem);
    }
  }
`;

export const StyledPrefersValue = styled.div`
  background-color: ${color('seq_blue_08')};
`;

export const StyledOfferedValue = styled.div`
  background-color: ${color('seq_blue_05')};

  &.reverse {
    z-index: -1;
  }
`;

export const StyledLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
`;

export const StyledLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('sm')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('medium')};
  white-space: nowrap;

  &::before {
    content: '';
    width: ${spacing('md')};
    height: ${spacing('md')};
    border-radius: ${radius('sm')};
    background-color: ${color('seq_blue_08')};
  }

  &:nth-child(2)::before {
    background-color: ${color('seq_blue_05')};
  }
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing('xl2')};
  gap: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: flex-start;
  }

  img {
    max-width: 15.5rem;
    border-radius: ${radius('lg')};
  }
`;

export const StyledText = styled.div`
  line-height: 1.5;

  p {
    margin-top: 0;
  }
`;
